import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { getPendingCandidates } from '../actions';

const usePendingCandidatesList = () => {
  const dispatch = useDispatch();
  const getPendingCandidatesHandler = useCallback(() => dispatch(getPendingCandidates()), [
    dispatch,
  ]);
  useEffect(() => {
    getPendingCandidatesHandler();
  }, [getPendingCandidatesHandler]);
  const pendingCandidates = useSelector<any, any>(state => state.pendingCandidates);

  return { pendingCandidates };
};

export default usePendingCandidatesList;
